module.exports = flarum.core.compat['components/PermissionDropdown'];